import React from "react";
import { Facebook, Instagram, Youtube, Linkedin } from "lucide-react";

const TikTok = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16.5 3c.3 2.2 1.6 3.9 3.9 4.2v2.5c-1.4.1-2.7-.3-3.9-1v6.1c0 3.4-2.5 5.7-5.6 5.7-2.9 0-5.3-2.2-5.3-5.1 0-3 2.4-5.1 5.3-5.1.3 0 .6 0 .9.1v2.6c-.3-.1-.6-.2-.9-.2-1.4 0-2.5 1-2.5 2.5s1.1 2.5 2.5 2.5c1.5 0 2.7-1.1 2.7-3.2V3h2.9z" />
  </svg>
);

export const SOCIAL = [
  { name: "Facebook", href: "https://www.facebook.com/goldenstatesafety", Icon: Facebook },
  { name: "Instagram", href: "https://www.instagram.com/goldenstatesafety/", Icon: Instagram },
  { name: "YouTube", href: "https://www.youtube.com/@GoldenStateSafety", Icon: Youtube },
  { name: "TikTok", href: "https://www.tiktok.com/@goldenstatesafety?lang=en", Icon: TikTok },
  { name: "LinkedIn", href: "https://www.linkedin.com/in/troy-taylor-70321a435/", Icon: Linkedin },
];

export const Socials = ({ className = "" }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid="social-links">
    {SOCIAL.map(({ name, href, Icon }) => (
      <a
        key={name}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={name}
        data-testid={`social-${name.toLowerCase()}`}
        className="h-10 w-10 rounded-full border border-white/12 bg-white/[0.03] text-slate-300 flex items-center justify-center hover:text-[#060c1f] hover:bg-amber-400 hover:border-amber-400 transition-colors"
      >
        <Icon size={18} />
      </a>
    ))}
  </div>
);
